import { useDispatch } from 'react-redux';
import { AppDispatch } from './rootReducer';

export const useTypedDispatch = () => useDispatch<AppDispatch>();
